import { loadStripe } from '@stripe/stripe-js';

const stripePromisesByKey = new Map();

/**
 * Returns a cached `loadStripe` promise for the given publishable key so the
 * Stripe.js script loads once per key across the app.
 *
 * @param {string} publishableKey
 * @returns {Promise<import('@stripe/stripe-js').Stripe|null>|null}
 */
export const getStripePromise = publishableKey => {
  if (!publishableKey) {
    return null;
  }
  if (!stripePromisesByKey.has(publishableKey)) {
    stripePromisesByKey.set(publishableKey, loadStripe(publishableKey));
  }
  return stripePromisesByKey.get(publishableKey);
};

// Deferred payment-mode group for a standalone AddressElement. The amount is a
// stable placeholder (no PaymentElement is mounted here); mirrors the sibling
// checkout, which uses `mode: 'payment'` with an amount fallback.
export const ADDRESS_ELEMENTS_OPTIONS = { mode: 'payment', amount: 100, currency: 'usd' };
